const API_KEY = "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJkNjBjNzQ5MWI1ODBiYTM5MTkxYmUxYmM1MTZkMmJlMiIsIm5iZiI6MTcxOTMxNzMxMS41ODI4NjksInN1YiI6IjY2N2FhZDk5ZDMxOTQ0ZDM3MDE1OTZhZCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.FSfDtUpsYOy9O6iOozOgOM0PbmM_QJX9al_SxJdzI4w";
const BASE_URL = "https://api.themoviedb.org/3";

const requests = {
    fetchTrending: `${BASE_URL}/trending/movie/day?language=en-US&api_key=${API_KEY}`,
    personTrending: `${BASE_URL}/trending/person/day?language=en-US&api_key=${API_KEY}`,
    tvTrending: `${BASE_URL}/trending/tv/day?language=en-US&api_key=${API_KEY}`
};

export default requests;
